<div class="container collection">
  <lib-collections
      *ngIf="data!"
      [isCategoryFilter]="true"
      [data]="data" >
  </lib-collections>
</div>